export function arrayJoin (array, separator) {
    return Array.isArray(array) && array.length > 0
      ? array.reduce((result, item) => result + separator + item)
      : "";
}